export default {
  returnToCall: 'Retourner à l\'appel',
};
